<template>
  <div class="d-flex justify-end">
    <v-tooltip bottom max-width="200px">
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <a
            v-if="data"
            class="link-to-planner"
            target="_blank"
            rel="noopener noreferrer"
            :href="linkToPlanner"
          >
            <div class="d-flex planner-icon-container cursor-pointer p-1">
              <img class="planner-icon" alt="planner-icon" :src="PlannerIcon" />
              <p class="m-0 ml-1 link-text">
                {{ $t('common.synced') }}
              </p>
            </div>
          </a>
        </div>
      </template>
      {{ tooltipMessage }}
    </v-tooltip>
  </div>
</template>

<script>
import PlannerIcon from '@/assets/images/planner-icon.png'

export default {
  name: 'PlannerIntegrationBadge',

  props: {
    data: {
      type: Object,
      default: null,
    },
    tooltipMessage: String,
  },

  data() {
    return {
      PlannerIcon,
    }
  },

  computed: {
    linkToPlanner() {
      return `https://tasks.office.com/Home/Task/${this.data?.externalEntityId}`
    },
  },
}
</script>

<style scoped lang="scss">
.planner-icon-container {
  background-color: #f1faf1;
  border-radius: 4px;
  height: 20px;
}
.link-to-planner {
  text-decoration: none;
}
.link-text {
  font-size: 10px;
  line-height: 14px;
  color: #0e700e;
  padding-right: 6px;
}
.planner-icon {
  width: 10px;
}
</style>
